var React = require('react');

function LogoIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"lale_1","data-name":"lale 1","d":"M888,231.948s-70.931,379.2-262.462,370.987C706.28,559.67,730.344,287.507,730.344,287.507ZM425.78,288.4,570,197l141.532,89.61S698.992,609.092,571.792,611,425.78,288.4,425.78,288.4ZM252,231.948s70.931,379.2,262.462,370.987C433.72,559.67,409.656,287.507,409.656,287.507Z","transform":"translate(-252 -197)","fill":"#ffffff"}));
}

LogoIcon.defaultProps = {"width":"636","height":"414.008","viewBox":"0 0 636 414.008"};

module.exports = LogoIcon;

LogoIcon.default = LogoIcon;
